import { CardActionArea, Link } from '@material-ui/core';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { Box, TextBox } from '@superdispatch/ui-lab';
import styled from 'styled-components';
import LoadsMap from './SuggestedLoadsMap.png';

const Wrapper = styled(CardActionArea)`
  width: 300px;
  border-radius: 4px;
  border-width: 1px;
  border-color: ${ColorDynamic.Silver400};
  background-color: ${ColorDynamic.White};
  scroll-snap-align: center;
`;

interface Props {
  onClick: () => void;
}

export function SuggestedLoadsSliderLastCard({ onClick }: Props) {
  return (
    <Wrapper onClick={onClick}>
      <Box paddingTop="medium" paddingLeft="small" paddingRight="small">
        <Stack align="center">
          <img
            height="88px"
            loading="lazy"
            src={LoadsMap}
            alt="Suggested loads map"
          />

          <Stack space="small" align="center">
            <TextBox align="center">
              Super Loadboard offers you <br /> 500+ daily exclusive loads you
              can <br />
              book 24/7 from 100+ shippers
            </TextBox>

            <Link href="#" color="primary">
              View All Suggested Loads
            </Link>
          </Stack>
        </Stack>
      </Box>
    </Wrapper>
  );
}
